export default {"src":"/_next/static/media/Solar-lenders.c32329a8.svg","height":1600,"width":1600};